import { Page, openPage } from '#/views/libs/pages';
import { createAreaSelectorPage } from '#/views/index/areas/AreaSelectorPage';
import { createCatvInfoPage } from '#/views/index/catv/CatvInfoPage';
import { createRiverInfoViewerPage } from '#/views/index/city/RiverInfoViewerPage';
import { createRootPageToolbar } from '#/views/components/RootPageToolbar';

import template from './CityInfoPage.html';
import { createMultiLineThumbnailSelector } from '#/views/components/thumbnails/MultiLineThumbnailSelector';
import { Doc } from '#/models/docs/Doc';
import { createPdfViewerPage } from '#/views/components/pdf/PdfViewerPage';

export interface CityInfoPageOptions {}

export function createCityInfoPage(options: CityInfoPageOptions): Page {
  const showBlue = () => {};

  const showRed = () => {
    openPage(createAreaSelectorPage({}));
  };

  const showGreen = () => {};

  const showYellow = () => {
    openPage(createCatvInfoPage({}));
  };

  const $toolbar = createRootPageToolbar();

  $toolbar.find('.btn-primary').on('click', (e) => {
    showBlue();
  });
  $toolbar.find('.btn-danger').on('click', (e) => {
    showRed();
  });
  $toolbar.find('.btn-success').on('click', (e) => {
    showGreen();
  });
  $toolbar.find('.btn-warning').on('click', (e) => {
    showYellow();
  });

  const $main = $(template);

  $main.find('.CityInfoPage__openRiverInfo').on('click', (e) => {
    e.preventDefault();
    openPage(createRiverInfoViewerPage({}));
  });

  // 広報伊万里
  $main.find('.CityInfoPage__kouhou').after(
    ...createMultiLineThumbnailSelector(Doc.imari.map(Doc.toPdfDocument), {
      aspectRatio: 'auto',
      colClass: 'col-md-2',
      cols: 6,
      setThumbnail: ($thumbnail, item) => {
        $thumbnail.find('img').attr('src', item.thumbnailUrl);
        $thumbnail.find('h3').text(item.title);
      },
      onFocused(_, item) {},
      onClicked(_, item) {
        openPage(createPdfViewerPage({ pdfDocument: item }));
      },
    })
  );

  $('body').append($toolbar);
  $('body').append($main);

  return {
    show: () => {
      $toolbar.show();
      $main.show();
    },
    hide: () => {
      $toolbar.hide();
      $main.hide();
    },
    unmount: () => {},
    onKeydown: (e) => {
      switch (e.which) {
        case VK_BLUE:
          showBlue();
          break;
        case VK_RED:
          showRed();
          break;
        case VK_GREEN:
          showGreen();
          break;
        case VK_YELLOW:
          showYellow();
          break;
        default:
          break;
      }
    },
  };
}
